/*
 * Corner Boxe · quiz « Trouver mon équipement » (section cb-quiz)
 * - arbre des questions ci-dessous ; chaque fin de parcours renvoie une clé de résultat
 * - les produits de chaque résultat viennent des blocs de la section (données lues dans Shopify, JSON de la page)
 * - un produit absent (brouillon) ou épuisé est ignoré : l'option suivante prend sa place
 * - ajout au panier en une fois (/cart/add.js), puis ouverture du tiroir panier du thème
 * - ?depart=sac|punching|gants|vitesse|support|equiper démarre directement à la bonne branche
 */
(() => {
  if (window.cbQuizLoaded) return;
  window.cbQuizLoaded = true;

  /* ---------- Arbre des questions ---------- */

  // Chaque réponse : l (libellé), r (formulation reprise dans « Parce que vous avez répondu »), set (état mis à jour)
  const TREE = {
    quoi: {
      q: 'Que cherchez-vous ?',
      a: [
        { l: 'Un sac de frappe', set: { branch: 'sac' } },
        { l: 'Un punching-ball', set: { branch: 'punching' } },
        { l: 'Des gants', set: { branch: 'gants' } },
        { l: 'Une poire ou un ballon de vitesse', set: { branch: 'vitesse' } },
        { l: 'Un support pour accrocher mon sac', set: { branch: 'support' } },
        { l: 'Je ne sais pas encore, je veux m’équiper pour boxer chez moi', set: { branch: 'equiper' } },
      ],
      next: (s) => (s.branch === 'support' ? 'support_percer' : 'qui'),
    },
    qui: {
      q: 'Pour qui ?',
      a: [
        { l: 'Pour moi', set: { who: 'moi' } },
        { l: 'Pour un enfant', r: 'pour un enfant', set: { who: 'enfant' } },
      ],
      next: (s) => {
        if (s.who === 'enfant') {
          if (s.branch === 'sac') return { result: 'sac-enfant' };
          if (s.branch === 'punching') return { result: 'punching-enfant' };
          if (s.branch === 'vitesse') return { result: 'vitesse-enfant' };
          if (s.branch === 'gants') return 'age';
          return 'logement';
        }
        return { sac: 'percer', punching: 'lieu', gants: 'discipline', vitesse: 'fixation', equiper: 'logement' }[s.branch];
      },
    },
    age: {
      q: 'Son âge ?',
      a: [
        { l: 'Moins de 10 ans', r: 'moins de 10 ans', set: { oz: '4 oz' } },
        { l: '10 ans et plus', r: '10 ans et plus', set: { oz: '6 oz' } },
      ],
      next: (s) => (s.branch === 'equiper' ? { result: `equiper-enfant-${s.logement}` } : { result: 'gants-enfant' }),
    },

    /* Sac de frappe */
    percer: {
      q: 'Pouvez-vous percer ?',
      a: [
        { l: 'Oui', set: { percer: 'oui' } },
        { l: 'Non', r: 'vous ne pouvez pas percer', set: { percer: 'non', ou: 'sol' } },
        { l: 'Je ne sais pas', r: 'vous ne savez pas si vous pouvez percer', set: { percer: 'nsp', ou: 'incertain' } },
      ],
      next: (s) => (s.percer === 'oui' ? 'ou' : 'frappe'),
    },
    ou: {
      q: 'Où ?',
      a: [
        { l: 'Au plafond, en béton ou sur une poutre', r: 'plafond en béton ou poutre', set: { ou: 'plafond' } },
        { l: 'Dans un mur porteur', r: 'mur porteur', set: { ou: 'mur' } },
        { l: 'Plaque de plâtre, ou je ne sais pas', r: 'plaque de plâtre ou support incertain', set: { ou: 'incertain' } },
      ],
      next: () => 'frappe',
    },
    frappe: {
      q: 'Vous frappez avec…',
      a: [
        { l: 'Les poings', r: 'les poings', set: { frappe: 'poings' } },
        { l: 'Les poings et les pieds', r: 'les poings et les pieds', set: { frappe: 'pieds' } },
      ],
      next: (s) => ({ result: `sac-${s.ou}-${s.frappe}` }),
    },

    /* Punching-ball */
    lieu: {
      q: 'Où l’installer ?',
      a: [
        { l: 'Au sol, dans un coin de pièce', r: 'au sol', set: { lieu: 'sol' } },
        { l: 'Sur un mur lisse (carrelage, vitre)', r: 'sur un mur lisse', set: { lieu: 'mur' } },
      ],
      next: (s) => (s.lieu === 'sol' ? 'travail' : { result: 'punching-mur' }),
    },
    travail: {
      q: 'Ce que vous voulez travailler',
      a: [
        { l: 'Vous défouler', r: 'vous défouler', set: { travail: 'defouler' } },
        { l: 'La précision', r: 'la précision', set: { travail: 'precision' } },
        { l: 'Les réflexes et l’esquive', r: 'les réflexes et l’esquive', set: { travail: 'reflexes' } },
      ],
      next: (s) => ({ result: `punching-sol-${s.travail}` }),
    },

    /* Gants */
    discipline: {
      q: 'Votre discipline ?',
      a: [
        { l: 'Boxe anglaise ou pieds-poings', r: 'boxe anglaise ou pieds-poings', set: { discipline: 'boxe' } },
        { l: 'MMA', r: 'MMA', set: { discipline: 'mma' } },
      ],
      next: (s) => (s.discipline === 'boxe' ? 'poids' : { result: 'gants-mma' }),
    },
    poids: {
      q: 'Votre poids ?',
      a: [
        { l: 'Moins de 55 kg', r: 'moins de 55 kg', set: { oz: '8 oz' } },
        { l: '55 à 70 kg', r: '55 à 70 kg', set: { oz: '10 oz' } },
        { l: '70 à 85 kg', r: '70 à 85 kg', set: { oz: '12 oz' } },
        { l: 'Plus de 85 kg', r: 'plus de 85 kg', set: { oz: '14 oz' } },
      ],
      next: () => ({ result: 'gants-boxe' }),
    },

    /* Vitesse */
    fixation: {
      q: 'Où la fixer ?',
      a: [
        { l: 'Au plafond et au sol', r: 'plafond et sol', set: { fixation: 'plafond' } },
        { l: 'Au mur', r: 'au mur', set: { fixation: 'mur' } },
      ],
      next: (s) => ({ result: `vitesse-${s.fixation}` }),
    },

    /* Support */
    support_percer: {
      q: 'Pouvez-vous percer un mur porteur ?',
      a: [
        { l: 'Oui', r: 'vous pouvez percer un mur porteur', set: { mur: 'oui' } },
        { l: 'Non', r: 'vous ne pouvez pas percer', set: { mur: 'non' } },
      ],
      next: (s) => (s.mur === 'oui' ? 'charge' : { result: 'support-sans-percage' }),
    },
    charge: {
      q: 'Le poids de votre sac une fois rempli ?',
      a: [
        { l: '45 kg ou moins', r: 'un sac de 45 kg ou moins', set: { charge: 'leger' } },
        { l: 'Plus de 45 kg', r: 'un sac de plus de 45 kg', set: { charge: 'lourd' } },
      ],
      next: (s) => ({ result: `support-${s.charge}` }),
    },

    /* M'équiper */
    logement: {
      q: 'Chez vous, pouvez-vous percer ?',
      a: [
        { l: 'Oui, je peux percer', r: 'vous pouvez percer', set: { logement: 'percer' } },
        { l: 'Non', r: 'vous ne pouvez pas percer', set: { logement: 'sol' } },
      ],
      next: (s) => (s.who === 'enfant' ? 'age' : 'niveau'),
    },
    niveau: {
      q: 'Votre niveau ?',
      a: [
        { l: 'Je n’ai jamais boxé', r: 'vous n’avez jamais boxé', set: { niveau: 'debutant' } },
        { l: 'Je reprends', r: 'vous reprenez', set: { niveau: 'reprise' } },
        { l: 'Je pratique régulièrement', r: 'vous pratiquez régulièrement', set: { niveau: 'regulier' } },
      ],
      next: () => 'objectif',
    },
    objectif: {
      q: 'Votre objectif ?',
      a: [
        { l: 'Me défouler', r: 'vous défouler', set: { objectif: 'defouler' } },
        { l: 'Apprendre la technique', r: 'apprendre la technique', set: { objectif: 'technique' } },
        { l: 'Travailler mes réflexes', r: 'travailler vos réflexes', set: { objectif: 'reflexes' } },
      ],
      next: (s) => {
        if (s.logement === 'percer') return { result: s.objectif === 'reflexes' ? 'equiper-percer-reflexes' : 'equiper-percer-frappe' };
        return { result: `equiper-sol-${s.objectif}` };
      },
    },
  };

  const DEPARTS = ['sac', 'punching', 'gants', 'vitesse', 'support', 'equiper'];

  // Nombre maximal de questions restantes depuis une question (elle comprise), pour la barre de progression
  const remaining = (id, state) => {
    const node = TREE[id];
    return 1 + Math.max(...node.a.map((answer) => {
      const next = node.next({ ...state, ...answer.set });
      return typeof next === 'string' ? remaining(next, { ...state, ...answer.set }) : 0;
    }));
  };

  /* ---------- Outils ---------- */

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const joinFr = (list) => {
    const quoted = list.map((item) => `« ${item} »`);
    return quoted.length > 1 ? `${quoted.slice(0, -1).join(', ')} et ${quoted[quoted.length - 1]}` : quoted[0] || '';
  };

  // Variante recommandée : valeur d'option égale à la consigne (ex. « 12 oz », « 80 cm (S) ») et disponible. Sans consigne,
  // la première variante disponible ; consigne introuvable (ex. 14 oz absent du modèle) : produit ignoré.
  const pickVariant = (product, hint) => {
    const available = product.variants.filter((variant) => variant.available);
    const wanted = (hint || '').trim().toLowerCase();
    if (!wanted) return available[0];
    return available.find((variant) => variant.options.some((option) => option.toLowerCase() === wanted));
  };

  /* ---------- Composant ---------- */

  class CbQuiz {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse(root.querySelector('[data-cb-quiz-data]').textContent);
      this.products = Object.fromEntries(this.data.products.map((product) => [product.handle, product]));
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: this.data.currency });
      this.screen = root.querySelector('[data-cb-quiz-screen]');
      this.progress = root.querySelector('[data-cb-quiz-progress]');
      this.backButton = root.querySelector('[data-cb-quiz-back]');

      root.querySelector('[data-cb-quiz-restart]').addEventListener('click', () => this.start(null));
      this.backButton.addEventListener('click', () => this.back());
      this.screen.addEventListener('click', (event) => this.onClick(event));
      this.screen.addEventListener('change', (event) => this.onChange(event));

      const depart = new URLSearchParams(window.location.search).get('depart');
      this.start(DEPARTS.includes(depart) ? depart : null);
    }

    start(depart) {
      this.history = [];
      this.state = {};
      this.answers = [];
      this.skipped = depart ? 1 : 0; // lien direct : la question 1 compte comme répondue dans la progression

      if (depart) {
        const first = TREE.quoi.a.find((answer) => answer.set.branch === depart);
        this.state = { ...first.set };
        this.show(TREE.quoi.next(this.state), false);
      } else {
        this.show('quoi', false);
      }
    }

    show(target, focus = true) {
      this.current = target;

      if (typeof target === 'string') {
        this.renderQuestion(target);
      } else {
        this.renderResult(target.result);
      }

      this.backButton.hidden = this.history.length === 0;
      if (focus) this.screen.querySelector('[data-cb-quiz-focus]')?.focus({ preventScroll: true });
      if (focus && this.root.getBoundingClientRect().top < 0) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    setProgress(ratio) {
      const percent = Math.round(ratio * 100);
      this.progress.style.setProperty('--cb-quiz-progress', `${percent}%`);
      this.progress.setAttribute('aria-valuenow', percent);
    }

    renderQuestion(id) {
      const node = TREE[id];
      const done = this.history.length + this.skipped;
      this.setProgress((done + 1) / (done + remaining(id, this.state)));

      this.screen.innerHTML = `
        <h2 class="cb-quiz__question" tabindex="-1" data-cb-quiz-focus>${escapeHtml(node.q)}</h2>
        <div class="cb-quiz__answers">
          ${node.a.map((answer, index) => `<button type="button" class="cb-quiz__answer" data-cb-quiz-answer="${index}">${escapeHtml(answer.l)}</button>`).join('')}
        </div>`;
    }

    answer(index) {
      const node = TREE[this.current];
      const choice = node.a[index];
      this.history.push({ node: this.current, state: { ...this.state }, answers: [...this.answers] });
      this.state = { ...this.state, ...choice.set };
      if (choice.r) this.answers.push(choice.r);
      this.show(node.next(this.state));
    }

    back() {
      const previous = this.history.pop();
      if (!previous) return;
      this.state = previous.state;
      this.answers = previous.answers;
      this.show(previous.node);
    }

    /* ---------- Résultats ---------- */

    hint(raw) {
      return (raw || '').replace('[oz]', this.state.oz || '');
    }

    // Produits d'une liste ; null si l'un d'eux est absent ou épuisé (l'option est alors ignorée)
    resolve(items) {
      const lines = [];
      for (const item of items) {
        const product = this.products[item.handle];
        if (!product || !product.available) return null;
        const variant = pickVariant(product, this.hint(item.hint));
        if (!variant) return null;
        lines.push({ product, variant });
      }
      return lines.length ? lines : null;
    }

    reasonSentence(extra) {
      const base = this.answers.length ? `${this.data.texts.because} ${joinFr(this.answers)}` : '';
      if (base && extra) return `${base} : ${extra}`;
      return base ? `${base}.` : extra;
    }

    renderLines(lines, groupId) {
      return lines.map((line, index) => {
        const { product, variant } = line;
        const available = product.variants.filter((v) => v.available);
        const select = available.length > 1
          ? `<label class="cb-quiz__variant"><span class="sr-only">${escapeHtml(this.data.texts.variant)}</span>
               <select data-cb-quiz-variant="${groupId}" data-line="${index}">
                 ${available.map((v) => `<option value="${v.id}" ${v.id === variant.id ? 'selected' : ''}>${escapeHtml(v.title)}</option>`).join('')}
               </select></label>`
          : '';
        return `
          <li class="cb-quiz__line">
            <a class="cb-quiz__img" href="${product.url}" tabindex="-1" aria-hidden="true">${product.image ? `<img src="${product.image}" alt="" loading="lazy" width="96" height="96">` : ''}</a>
            <div class="cb-quiz__line-info">
              <a class="cb-quiz__name" href="${product.url}">${escapeHtml(product.title)}</a>
              ${select}
              <span class="cb-quiz__price" data-cb-quiz-price="${groupId}-${index}">${this.money.format(variant.price / 100)}</span>
            </div>
          </li>`;
      }).join('');
    }

    totalOf(lines) {
      return lines.reduce((sum, line) => sum + line.variant.price, 0);
    }

    buttonLabel(template, lines) {
      return escapeHtml(template.replace('[total]', this.money.format(this.totalOf(lines) / 100)));
    }

    renderResult(key) {
      this.setProgress(1);
      this.groups = {};
      const result = this.data.results[key];
      const texts = this.data.texts;
      let body = '';

      if (result && result.type === 'pack') {
        let essential = this.resolve(result.essential);
        if (essential && essential.length < result.required) essential = null; // un produit du pack est en brouillon
        const showComplete = this.state.who !== 'enfant' && this.state.niveau && this.state.niveau !== 'debutant';
        let complete = essential && showComplete && result.extra.length ? this.resolve([...result.essential, ...result.extra]) : null;
        if (complete && complete.length <= essential.length) complete = null;

        if (essential) {
          this.groups.essential = essential;
          if (complete) this.groups.complete = complete;
          const pack = (id, title, intro, lines) => `
            <article class="cb-card cb-quiz__pack">
              <h3 class="cb-quiz__pack-title">${escapeHtml(title)}</h3>
              ${intro ? `<p class="cb-quiz__reason">${escapeHtml(intro)}</p>` : ''}
              <ul class="cb-quiz__lines">${this.renderLines(lines, id)}</ul>
              <p class="cb-quiz__total"><span>${escapeHtml(texts.total)}</span> <strong data-cb-quiz-total="${id}">${this.money.format(this.totalOf(lines) / 100)}</strong></p>
              <button type="button" class="cb-btn" data-cb-quiz-add="${id}">${this.buttonLabel(texts.pack_button, lines)}</button>
              <p class="cb-quiz__error" data-cb-quiz-error="${id}" hidden></p>
            </article>`;
          body = `
            <p class="cb-quiz__reason cb-quiz__reason--lead">${escapeHtml(this.reasonSentence(result.reason))}</p>
            <div class="cb-quiz__packs ${complete ? 'cb-quiz__packs--two' : ''}">
              ${pack('essential', texts.essential, texts.essential_intro, essential)}
              ${complete ? pack('complete', texts.complete, texts.complete_intro, complete) : ''}
            </div>`;
        }
      } else if (result) {
        const options = result.options
          .map((option) => ({ option, lines: this.resolve(option.items) }))
          .filter((entry) => entry.lines && entry.lines.length >= entry.option.required)
          .slice(0, 3);

        body = options.map((entry, index) => {
          const id = `option${index}`;
          this.groups[id] = entry.lines;
          return `
            <article class="cb-card cb-quiz__option">
              <p class="cb-eyebrow">${escapeHtml(index === 0 ? texts.first_choice : texts.other_choice)}</p>
              <ul class="cb-quiz__lines">${this.renderLines(entry.lines, id)}</ul>
              <p class="cb-quiz__reason">${escapeHtml(this.reasonSentence(entry.option.reason))}</p>
              ${entry.lines.length > 1 ? `<p class="cb-quiz__total"><span>${escapeHtml(texts.total)}</span> <strong data-cb-quiz-total="${id}">${this.money.format(this.totalOf(entry.lines) / 100)}</strong></p>` : ''}
              <button type="button" class="cb-btn" data-cb-quiz-add="${id}">${this.buttonLabel(texts.add_button, entry.lines)}</button>
              <p class="cb-quiz__error" data-cb-quiz-error="${id}" hidden></p>
            </article>`;
        }).join('');
      }

      const contact = result && result.contact ? `<div class="cb-quiz__contact">${texts.contact_html}</div>` : '';
      const empty = !body ? `<p class="cb-quiz__empty">${escapeHtml(texts.empty)}</p>` : '';

      this.screen.innerHTML = `
        <h2 class="cb-quiz__question" tabindex="-1" data-cb-quiz-focus>${escapeHtml((result && result.title) || texts.result_title)}</h2>
        ${contact}
        <div class="cb-quiz__results ${result && result.type === 'pack' ? 'cb-quiz__results--packs' : ''}">${body}${empty}</div>`;
    }

    onChange(event) {
      const select = event.target.closest('[data-cb-quiz-variant]');
      if (!select) return;
      const group = this.groups[select.dataset.cbQuizVariant];
      const line = group[Number(select.dataset.line)];
      line.variant = line.product.variants.find((variant) => String(variant.id) === select.value) || line.variant;

      const id = select.dataset.cbQuizVariant;
      this.screen.querySelector(`[data-cb-quiz-price="${id}-${select.dataset.line}"]`).textContent = this.money.format(line.variant.price / 100);
      const total = this.screen.querySelector(`[data-cb-quiz-total="${id}"]`);
      if (total) total.textContent = this.money.format(this.totalOf(group) / 100);
      const template = id.startsWith('option') ? this.data.texts.add_button : this.data.texts.pack_button;
      this.screen.querySelector(`[data-cb-quiz-add="${id}"]`).innerHTML = this.buttonLabel(template, group);
    }

    onClick(event) {
      const answer = event.target.closest('[data-cb-quiz-answer]');
      if (answer) return this.answer(Number(answer.dataset.cbQuizAnswer));

      const add = event.target.closest('[data-cb-quiz-add]');
      if (add) this.addToCart(add, add.dataset.cbQuizAdd);
    }

    // Même enchaînement que le formulaire produit du thème : sections du tiroir regroupées, puis variant:add et cart:change
    async addToCart(button, id) {
      const lines = this.groups[id];
      const error = this.screen.querySelector(`[data-cb-quiz-error="${id}"]`);
      error.hidden = true;
      button.setAttribute('aria-busy', 'true');

      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: lines.map((line) => ({ id: line.variant.id, quantity: 1 })),
            sections: sections.join(','),
            sections_url: window.location.pathname,
          }),
        });
        const json = await response.json();
        if (!response.ok) throw new Error(json.description || json.message);

        const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cart.sections = json.sections;
        button.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
      } catch (exception) {
        error.textContent = exception.message || this.data.texts.add_error;
        error.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } finally {
        button.removeAttribute('aria-busy');
      }
    }
  }

  const init = () => {
    document.querySelectorAll('[data-cb-quiz]').forEach((root) => {
      if (root.dataset.cbReady) return;
      root.dataset.cbReady = 'true';
      new CbQuiz(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
